module.exports = __webpack_public_path__ + "static/media/asu_logo.733df2ed.png";